import palette from '../../../themev5/palette';

const styles = {
  actionBar: {
    px: 2,
    pb: 1
  },
  greenButton: {
    background: palette.green.accept,
    color: 'whitesmoke',
    textTransform: 'none'
  },
  greenButtonWithMargin: {
    background: palette.green.accept,
    marginRight: '8px',
    color: 'whitesmoke',
    textTransform: 'none'
  },
  loadingBox: {
    width: '100%',
    height: 400,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    px: 2,
    pb: 2
  },
  progressBar: {
    width: '100%',
    maxWidth: 400,
    marginBottom: '1em'
  },
  loadingText: {
    fontSize: '25px',
    color: palette.green.accept
  },
  loadingSubText: {
    fontSize: '20px',
    color: palette.green.accept,
    mt: 1
  },
  fileOpenBox: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: 320,
    justifyContent: 'center',
    alignItems: 'center',
    pb: 2
  },
  fileOpenText: {
    fontSize: '25px',
    color: palette.green.accept,
    mb: 2
  },
  confirmTitle: {
    color: palette.green.accept,
    fontSize: '20px',
    fontWeight: 'bold'
  },
  confirmBody: {
    fontSize: '16px',
    color: 'GrayText'
  }
};

export default styles;
